import PropTypes from 'prop-types';
import React from 'react';

import SearchFilter from '../containers/search-filter';
import TagFilter from '../containers/tag-filter';
import Timeline from '../containers/timeline';

function handleSubmit(e) {
	e.preventDefault();

	if (document.activeElement instanceof HTMLElement) {
		document.activeElement.blur();
	}
}

const Filters = ({showSearchOnly, reset, willReset}) => (
	<form className="bsknacht17-filters" onSubmit={handleSubmit}>
		<div style={{display: showSearchOnly ? 'none' : 'block'}}>
			<Timeline />
		</div>

		<div className="bsknacht17-row bsknacht17-filters__group">
			<div
				className="bsknacht17-col"
				style={{
					flexGrow: 40,
					display: showSearchOnly ? 'none' : undefined,
				}}
			>
				<TagFilter />
			</div>

			<div
				className="bsknacht17-col"
				style={{flexGrow: showSearchOnly ? 80 : 40}}
			>
				<SearchFilter />
			</div>

			<div className="bsknacht17-col" style={{flexGrow: 20}}>
				<div className="bsknacht17-filter">
					<button
						type="button"
						onClick={reset}
						title={
							willReset
								? 'Filter zurücksetzen'
								: 'Zurück zur Liste'
						}
					>
						<span className="visuallyhidden">
							{willReset
								? 'Filter zurücksetzen'
								: 'Zurück zur Liste'}
						</span>
						<svg
							width="12px"
							height="12px"
							viewBox="0 0 12 12"
							version="1.1"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g stroke="black" strokeWidth="1" fill="none">
								<path d="M9.8751,9.877 L0.3541,0.356" />
								<path d="M0.3536,9.877 L9.8746,0.354" />
							</g>
						</svg>
					</button>
				</div>
			</div>
		</div>
	</form>
);

Filters.propTypes = {
	showSearchOnly: PropTypes.bool.isRequired,
	reset: PropTypes.func.isRequired,
	willReset: PropTypes.bool.isRequired,
};

export default Filters;
